import { getContainerInfo } from "./jsBridge";

// 检查当前app版本是否为新版
export function checkAppBuild(ios_build_min: number, android_build_min: number): Promise<boolean> {
  return getContainerInfo().then((info) => {
    const { platform, build } = info;
    if (platform === "ios") {
      return build >= ios_build_min;
    } else if (platform === "android") {
      return build >= android_build_min;
    }
    return false;
  });
}